export function formatTime(timestamp: number): string {
  const date = new Date(timestamp);
  return date.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatRelativeTime(timestamp: number): string {
  const now = Date.now();
  const diff = Math.floor((now - timestamp) / 1000);

  if (diff < 60) return "только что";
  if (diff < 3600) return `${Math.floor(diff / 60)} мин назад`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ч назад`;
  return new Date(timestamp).toLocaleDateString("ru-RU");
}

export function formatAccuracy(meters: number): string {
  if (meters < 100) return `±${Math.round(meters)}м`;
  if (meters < 1000) return `±${Math.round(meters / 10) * 10}м`;
  return `±${(meters / 1000).toFixed(1)}км`;
}
